'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-show.routes';

export class SurveyShowComponent {
  constructor(Auth, SurveysService, SurveyResultsService, dialogs, $uibModal, $stateParams, $scope) {
    'ngInject';

    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;
    this.$scope = $scope;

    this.model = {};
    this.surveyId = $stateParams.id;
    this.surveyResult = {
      survey: this.surveyId,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id
      }
    };

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.SurveysService.get({id: this.surveyId}, (survey) => {
      this.survey = survey;

      let schema = {
        "type": "object",
        "properties": {}
      };

      let form = [];

      for (let i=0; i<survey.questions.length; i++) {
        let key = "question_"+i;

        switch (survey.questions[i].type) {
          case 'text':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "string"
            };
            break;
          case 'select-one':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "string",
              enum: survey.questions[i].answers
            };
            break;
          case 'select-many':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "array",
              "items": {
                enum: survey.questions[i].answers
              }
            };
            break;
        }
        form.push(key);
      }

      this.schema = schema;
      this.form = form;
    }, err => {
      console.log("Could not retrieve survey from server.")
    })
  }

  /*
  openPreviewModal(eform) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: eform.data
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () {  },
      function () {  }
    );

  }*/

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The survey has been sent successfully");
        dlg.result.then(() => {
          that.sendSuccess = true;
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.surveyResult.answers = this.model;
      this.SurveyResultsService.save(this.surveyResult, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.surveyShow', [uiRouter])
  .config(routes)
  .component('surveyShow', {
    template: require('./survey-show.html'),
    controller: SurveyShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/show/survey-show.component.js